import * as taskName from './task-name'
import { createValidationMessage } from '../../../../validation/create-validation-message'

import { createUIDefinition } from '../default-task-definition'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'


export default createUIDefinition({
    taskName: taskName.SHIP_ALIGNER,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.DELIVERY_TRACKING_WIDGET,
            widgetProps: {
                showAlignerNumberCounted: true,
            },
        },
        {
            component: processUI.SHIPMENT_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.CUSTOMS_INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.SENT_EMAIL_WIDGET,
        },
        {
            component: processUI.INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.PAYMENT_LIST_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
        {
            component: processUI.TECHNICAL_LOG_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        if (eventName !== 'aligners_shipped') {
            return null
        }

        const messageList = []

        const alignerNumberCounted = context.alignerNumberCounted
        if (!alignerNumberCounted) {
            messageList.push(createValidationMessage('Please confirm number of aligner is counted.'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/ship-aligner.js